export const pageCtx: PageCtx = window.pageCtx;

export function getStateId(): string {
    return pageCtx.stateId;
}

export function getPts(): { [key: string]: string } {
    let pts = pageCtx.pts;
    if (typeof pts === 'string') {
        return pageCtx.pts = JSON.parse(pts);
    }
    return (pts || {});
}

export function getExternalLinkToken(): string {
    return pageCtx.externalLinkToken;
}

export function getUserId(): string {
    return pageCtx.uid;
}

export function getStaticResourceUrl() {
    return pageCtx.staticResourceUrl;
}
